import * as React from 'react';

export function useScrollTo(root: React.RefObject<HTMLElement>): (elementId: string) => void {
  return React.useCallback(
    (elementId: string) => {
      const element = document.getElementById(elementId);

      if (root.current && element) {
        const rootScrollWidth = root.current.scrollWidth;
        const rootWidth = root.current.getBoundingClientRect().width;
        const elementWidth = element.getBoundingClientRect().width;
        const leftPadding = (rootWidth - elementWidth) / 2;

        if (rootScrollWidth) {
          root.current.scroll({
            left: element.offsetLeft - leftPadding,
            behavior: 'smooth',
          });
        }
      }
    },
    [root],
  );
}
